var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { E_CORE_ACTION_TYPES } from './actionTypes';
var initialState = {
    urlConfigs: null,
    configs: null,
    realm: null,
    locale: null,
    notifications: [],
    filesUrls: {},
    apisStatus: null,
};
export var coreReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case E_CORE_ACTION_TYPES.RESET_CONF: {
            return initialState;
        }
        case E_CORE_ACTION_TYPES.UPDATE_URL_CONF_SUCCEEDED: {
            return __assign(__assign({}, state), { urlConfigs: action.urlConfigs, realm: action.urlConfigs.realm });
        }
        case E_CORE_ACTION_TYPES.FETCH_CONF_SUCCEEDED: {
            return __assign(__assign({}, state), { configs: action.configs });
        }
        case E_CORE_ACTION_TYPES.ADD_NOTIFICATION_SUCCEEDED:
        case E_CORE_ACTION_TYPES.REMOVE_NOTIFICATION_SUCCEEDED: {
            var notifications = action.notifications;
            return __assign(__assign({}, state), { notifications: notifications });
        }
        case E_CORE_ACTION_TYPES.ADD_FILE_URLS_SUCCEEDED: {
            return __assign(__assign({}, state), { filesUrls: __assign(__assign({}, state.filesUrls), action.filesUrls) });
        }
        case E_CORE_ACTION_TYPES.UPDATE_LOCALE: {
            return __assign(__assign({}, state), { locale: action.locale });
        }
        case E_CORE_ACTION_TYPES.PING_API_SUCCEEDED: {
            var apisStatus = action.apisStatus;
            return __assign(__assign({}, state), { apisStatus: apisStatus });
        }
        default:
            return state;
    }
};
